<template>
  <div class="loss-content">
    <div class="nav">
      <div class="nav-left">
        <div class="parallelogram-btn-left" @click="toMildew" :class="{'parallelogram-btn-active': lossType === 1}" style="margin-right: 0.5vw">
          <div>自然损耗</div>
        </div>
        <div class="parallelogram-btn-left" @click="toNatural" :class="{'parallelogram-btn-active': lossType === 2}" style="margin-right: 0.5vw">
          <div>霉变损耗</div>
        </div>
        <div class="parallelogram-btn-left" @click="toCrushed" :class="{'parallelogram-btn-active': lossType === 3}">
          <div>造碎损耗</div>
        </div>
      </div>
      <div class="nav-center"><div>{{title}}</div></div>
      <div class="nav-right">
        <div class="parallelogram-btn-right" :class="change === 1 ? className : ''" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" :class="change === 2 ? className : ''" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" :class="change === 3 ? className : ''" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" @click="toPests" :class="{'parallelogram-btn-active': lossType === 4}" style="margin-right: 0.5vw">
          <div>虫害损耗</div>
        </div>
        <div class="parallelogram-btn-right" @click="tCarbide" :class="{'parallelogram-btn-active': lossType === 5}" style="margin-right: 0.5vw">
          <div>碳化损耗</div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="loss-main">
        <div class="loss-main-top">
          <div class="loss-box">
            <div class="loss-m"></div>
            <div class="loss-box-data">
              <div class="item">本月损耗重量（g）</div>
              <div class="loss-m-color" v-loading="loading"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="transparent">{{loading ? '' : loseData.currentMonthLoss}}</div>
            </div>
          </div>
          <div class="loss-box">
            <div class="loss-y"></div>
            <div class="loss-box-data">
              <div class="item">本年损耗重量（g）</div>
              <div class="loss-y-color" v-loading="loading"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="transparent">{{loading ? '' : loseData.currentYearLoss}}</div>
            </div>
          </div>
          <div class="loss-box">
            <div class="loss-a"></div>
            <div class="loss-box-data">
              <div class="item">本年库存总量（g）</div>
              <div class="loss-a-color" v-loading="loading"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="transparent">{{loading ? '' : loseData.stockTotal}}</div>
            </div>
          </div>
          <div class="loss-box">
            <div class="loss-p"></div>
            <div class="loss-box-data">
              <div class="item">本年损耗占比（%）</div>
              <div class="loss-p-color" v-loading="loading"
                   element-loading-spinner="el-icon-loading"
                   element-loading-background="transparent">{{loading ? '' : loseData.yersRatioOfLoss}}</div>
            </div>
          </div>
        </div>
        <div class="loss-main-select">
          <div class="input-date-wrapper">
            <el-date-picker
              v-model="value"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div style="margin-right: 1vw">
            <LoadingTreeStack :moduleType="moduleType"  :content="siteName" :editCheckId="siteId" v-on:sendInfo = "showDropInfo"></LoadingTreeStack>
          </div>
          <div class="query button" @click="handleSearch()">查询</div>
          <div class="query button" @click="toLookDetail" style="margin-left: 1vw">查看详情</div>
        </div>
        <div class="loading-data" style="margin-top: 1vw" v-if="loading">
          <i class="el-icon-loading"></i>
          <div>加载中，请稍后···</div>
        </div>
        <div class="chart-wrapper" id="myChart16" v-show="!loading" v-if="rows.length > 0"></div>
        <div class="none-data" v-if="!loading && rows.length<1">暂无数据</div>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingTreeStack from '../../../components/LoadingTreeStack.vue'
import {indexLossStatistical} from '../../../api/maintain'
let echarts = require('echarts')
let myChart16
export default {
  name: 'Mildew',
  components: { LoadingTreeStack },
  data () {
    return {
      loading: true,
      className: 'parallelogram-btn-right_',
      change: 0,
      moduleType: '-1',
      value: '',
      title: '',
      lossType: 1,
      beginTime: '',
      endTime: '',
      siteId: '',
      siteType: '',
      siteName: '',
      rows: [],
      loseData: {
        currentMonthLoss: 0,
        currentYearLoss: 0,
        stockTotal: 0,
        yersRatioOfLoss: 0
      }
    }
  },
  created () {
    let _this = this
    this.lossType = parseInt(this.$route.query.lossType)
    if (isNaN(this.lossType)) {
      _this.lossType = 1
    }
    this.getTitle(_this.lossType)
    let a = 1
    setInterval(function () {
      _this.change = a
      a++
      if (a === 4) {
        a = 1
      }
    }, 1000)
    let b = 0
    setInterval(function () {
      b++
      if (b < 4) {
        _this.className = 'parallelogram-btn-right_'
      } else if (b < 7) {
        _this.className = 'parallelogram-btn-right__'
      } else if (b < 10) {
        _this.className = 'parallelogram-btn-right___'
      } else {
        b = 1
        _this.className = 'parallelogram-btn-right_'
      }
    }, 1000)
    _this.handleSearch()
  },
  watch: {
    '$route' () {
      this.getTitle(this.$route.query.lossType)
      this.lossType = parseInt(this.$route.query.lossType)
      if (isNaN(this.lossType)) {
        this.lossType = 1
        this.goPath(this.lossType)
      }
      this.handleSearch()
    },
    value: function () {
      this.beginTime = this.value !== null ? this.value[0] : ''
      this.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  methods: {
    handleSearch: function () {
      this.loading = true
      let body = {
        beginTime: this.beginTime,
        endTime: this.endTime,
        siteId: this.siteId,
        siteType: this.siteType,
        lossType: this.lossType
      }
      console.log(body)
      indexLossStatistical(body).then(res => {
        console.log(res)
        this.loading = false
        this.rows = res.data.lossStatiscalArray
        this.loseData.currentMonthLoss = res.data.currentMonthLoss || 0
        this.loseData.currentYearLoss = res.data.currentYearLoss || 0
        this.loseData.stockTotal = res.data.stockTotal || 0
        this.loseData.yersRatioOfLoss = res.data.yersRatioOfLoss || 0
        let that = this
        if (res.data.lossStatiscalArray && res.data.lossStatiscalArray.length > 0) {
          setTimeout(function () {
            that.getCharts()
          }, 200)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getTitle: function (lossType) {
      switch (lossType) {
        case 1:
          this.title = '自然损耗'
          break
        case 2:
          this.title = '霉变损耗'
          break
        case 3:
          this.title = '造碎损耗'
          break
        case 4:
          this.title = '虫害损耗'
          break
        case 5:
          this.title = '碳化损耗'
          break
      }
    },
    showDropInfo: function (data) {
      console.log(data)
      this.siteName = data.gatherSite
      this.siteId = data.id
      this.siteType = data.siteType
    },
    toLookDetail: function () {
      this.$router.push({
        path: '/loss/lookDetail',
        query: {
          index: '9',
          lossType: this.lossType
        }
      })
    },
    getCharts: function () {
      this.getChart16(0)
      window.onresize = function () {
        myChart16.resize()
      }
    },
    getChart16: function () {
      let date = []
      let value1 = []
      let value2 = []
      if (this.rows.length < 12) {
        this.percentage = 100
      } else {
        this.percentage = 1200 / this.rows.length
      }
      this.rows.map(item => {
        date.push(item.yearMonth)
        value1.push(item.lossCount)
        value2.push(item.ratioOfLoss)
      })
      myChart16 = echarts.init(document.getElementById('myChart16'))
      myChart16.setOption({
        textStyle: {color: '#00d2ff'},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {type: 'dashed'},
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          y: 'top',
          right: '5%',
          itemGap: 50,
          textStyle: {color: '#01c5f1'},
          data: [{name: '损耗标准值：0.008%', icon: 'none'}, {name: '损耗数量', icon: 'square'}, {name: '损耗占比'}]
        },
        grid: {
          top: '15%',
          right: '0.5%',
          left: '0.5%',
          bottom: '0',
          containLabel: true
        },
        xAxis: [
          {
            splitLine: {show: false},
            axisTick: false,
            axisLine: {
              lineStyle: {color: '#32b16c'}
            },
            type: 'category',
            data: date
          }
        ],
        yAxis: [
          {
            axisTick: false,
            axisLine: {
              lineStyle: {color: '#32b16c'}
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['#2a2f57']
              }
            },
            type: 'value',
            name: '数量/个'
          },
          {
            axisTick: false,
            axisLine: {
              lineStyle: {color: '#32b16c'}
            },
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['#2a2f57']
              }
            },
            type: 'value',
            name: '占比/%'
          }
        ],
        dataZoom: [
          {
            show: false,
            start: 0,
            end: this.percentage
          },
          {
            type: 'inside',
            start: 0,
            end: this.percentage
          },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 30,
            height: '80%',
            showDataShadow: false,
            left: '93%'
          }
        ],
        series: [
          {
            name: '损耗数量',
            barWidth: '40%',
            type: 'bar',
            symbol: 'circle',
            itemStyle: {
              normal: {
                label: {
                  show: 'true',
                  position: 'top',
                  color: '#ffffff'
                },
                lineStyle: {
                  color: '#32b16c'
                },
                color: '#32b16c'
              }
            },
            data: value1
          },
          {
            name: '损耗占比',
            type: 'line',
            symbol: 'circle',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#eb6100'
                },
                color: '#eb6100'
              }
            },
            data: value2
          }
        ]
      })
      let _this = this
      myChart16.on('click', function (params) {
        // 控制台打印数据的名称
        _this.$router.push({
          path: '/loss/lookDetail',
          query: {
            index: '9',
            lossType: _this.lossType
          }
        })
        console.log(params)
      })
    },
    toMildew: function () {
      this.lossType = 1
      this.goPath(this.lossType)
    },
    toNatural: function () {
      this.lossType = 2
      this.goPath(this.lossType)
    },
    toCrushed: function () {
      this.lossType = 3
      this.goPath(this.lossType)
    },
    toPests: function () {
      this.lossType = 4
      this.goPath(this.lossType)
    },
    tCarbide: function () {
      this.lossType = 5
      this.goPath(this.lossType)
    },
    goPath: function (lossType) {
      this.$router.push({
        path: '/loss',
        query: {
          index: '9',
          lossType: lossType
        }
      })
    }
  }
}
</script>

<style scoped>
@import "Loss.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/loss/Mildew.vue